//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueHorizontal from 'vue-horizontal'
export default {
  components: { VueHorizontal },
  props: ['mode', 'sport'],
  data() {
    return {
      loading: true,
      height: 0,
      hasPrev: false,
      hasNext: true,
      sportEvents: [],
      left: 0,
      originX: 0,
      originLeft: 0
    }
  },
  destroyed() {
    this.onMouseUp()
  },
  computed: {
    isAlwaysOpen() {
      if(this.mode == 'sport' && _.includes(['football'], this.sport) ){
        return true
      }
      if(this.mode == 'highlights' ){
        return true
      }
      return false;
    },
    isVisible() {
      if(this.mode == 'sport' && _.includes(['football', 'tennis', 'baseball', 'rugby', 'basketball', 'aussie-rules', 'cricket', 'ice-hockey'], this.sport) ){
        return true
      }
      if(this.mode == 'highlights' ){
        return true
      }
      return false;
    },
    hash() {
      return this.mode + '_' + this.sport;
    },
    events() {
      if(this.mode == 'sport'){
        return this.sportEvents;
      }
      return _.get(this.$store.state, 'games.featuredEvents', [])
    }
  },
  beforeDestroy: function () {
    emitter.off('*', this.onFeaturedEventChange)
  },
  watch: {
    hash: {
      handler: function (newVal, oldVal) {
        this.loading = true
        this.fetchEvents()
      }
    }
  },
  mounted() {
    this.currentEvents = []
    //this.loadCache()
    this.initInterval()

    emitter.on('*', this.onFeaturedEventChange)

    let clientWidth = _.get(this.$refs, 'carousel.clientWidth', 500)
    this.height = (clientWidth / 2 + 20) * (16 / 9)

    setInterval(() => {
      let clientWidth = _.get(this.$refs, 'carousel.clientWidth', 500)
      this.height = (clientWidth / 2 + 20) * (16 / 9)
    }, 1000)
  },
  methods: {
    onScroll({ left }) {
      this.left = left
    },
    onMouseDown(e) {
      this.originX = e.pageX
      this.originLeft = this.left

      window.addEventListener('mouseup', this.onMouseUp)
      window.addEventListener('mousemove', this.onMouseMove)
    },
    onMouseUp() {
      window.removeEventListener('mouseup', this.onMouseUp)
      window.removeEventListener('mousemove', this.onMouseMove)
    },
    onMouseMove(e) {
      const offset = e.pageX - this.originX
      const left = this.originLeft - offset
      this.$refs.horizontal.scrollToLeft(left, 'auto')
    },
    prev() {
      this.$refs.horizontal.prev()
    },
    next() {
      this.$refs.horizontal.next()
    },
    onScrollDebounce({ hasPrev, hasNext }) {
      this.hasPrev = hasPrev
      this.hasNext = hasNext
    },
    onFeaturedEventChange(type, e) {
      if (type == 'events') {
        if (_.size(_.intersection(e, this.currentEvents)) && !this.loading) {
          this.fetchEvents()
        }
      }
    },
    async initInterval() {
      this.fetchEvents()
    },
    handleSlideClick(dataset) {
      console.log('handleSlideClick', dataset)
      if (dataset.action) {
        this.$root.$emit(dataset.action)
      } else if (dataset.url) {
        this.$router.push(this.localePath({ path: dataset.url }))
      }
    },
    async loadCache() {
      try {
        if(this.mode == 'highlights') {
          let home_featured_events = await this.$cache().getItem('home_featured_events')
          this.$store.commit('games/setFeaturedEvents', home_featured_events)
        }
      } catch (e) {}
    },
    async fetchEvents() {
      this.loading = true
      try {
        const response = await this.$api().$get('/v1/betbuilder/precanned/featured', { params: {
          lang: this.lang,
          country: this.country,
          bookmaker: this.$config.BOOKMAKER,
          mode: this.mode,
          sport: this.sport,
        } })
        if(this.mode == 'highlights') {
          this.$cache().setItem('home_featured_events', response.events)
          this.$store.commit('games/setFeaturedEvents', response.events)
        }
        this.sportEvents = response.events
        this.currentEvents = _(response.events).map('id').value()
      } catch (e) {}
      this.loading = false
    }
  }
}
